import type { FaireProductEntity } from "../../entity_types/product";

export const p_mqrz4rc9jd: FaireProductEntity = {
  token: "p_mqrz4rc9jd",
  type: "product",
  name: "Rad Dad Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c07f7a1dff60eb889713d4e784b21116f526c27e31ad9f5f11823195b00290e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/61f3ef4c7edb1ef3800e0b8e73b03ec61ba0ab8a718cb84706bda81d7d8ac6f7.jpeg",
    "https://cdn.faire.com/fastly/56228793e82796dd427d5279a1c8596e0e81918619091e8d559921dbaea43add.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/354c964d5f1ce7251640feb1af2dacb32a983cf97acf9d23207cad2f46c0cb09.jpeg",
    "https://cdn.faire.com/fastly/f3011e7e4ba7fafdb5fed9788bfaa8255e1c7c06594e4c81f1ce85641e1afcbd.jpeg",
    "https://cdn.faire.com/fastly/b9f104b1c67cac86d9fb301050257fec877da9a8b51e91da9e7152c6adaaec20.jpeg",
    "https://cdn.faire.com/fastly/441107da14086188123c398cd15b2a6ab36c9d6721ba0cea824c0785fa727bcd.jpeg",
    "https://cdn.faire.com/fastly/883a74d3f4ee0f87a02e0b2248059a6dadbf23d137c38075671dd43fb71b6515.jpeg"
  ],
  priceDollars: 6.75,
  description: "Our 'Rad Dad' socks are perfect for dads everywhere, because even his feet deserve to be as cool as he thinks he is.\n\nPerfect Father’s Day gift!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:54.828Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
